module.exports = __webpack_public_path__ + "img/mh.7f1dbb85.svg";